<template>
  <el-table :data="chatter.manual_nudges">
    <el-table-column
      prop="stage"
      label="Статус"
      :formatter="(row: Chatter['manual_nudges'][number]) => getStatus(row.stage).label"
    />
    <el-table-column prop="manual_nudge_outcome_id" label="Причина">
      <template #default="scope">
        {{ outcomes.find((outcome) => outcome.id === scope.row.manual_nudge_outcome_id)?.value }}
      </template>
    </el-table-column>
    <el-table-column prop="comment" label="Комментарий" />
    <el-table-column
      prop="created_at"
      label="Дата"
      :formatter="(row: Chatter['manual_nudges'][number]) => formatToHumanReadable(row.created_at)"
    />
  </el-table>
  <br />
  <el-form style="width: 500px">
    <el-form-item label="Причина">
      <el-select v-model="newNudge.outcome" placeholder="Найти или создать" filterable allow-create>
        <el-option
          v-for="outcome in outcomes"
          :key="outcome.id"
          :label="outcome.value"
          :value="outcome"
        />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-input v-model="newNudge.comment" placeholder="Комментарий" type="textarea" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="addNudge">Добавить</el-button>
    </el-form-item>
  </el-form>
</template>

<script setup lang="ts">
import { api } from '@/api'
import type Chatter from '@/api/resources/chatters/model'
import { formatToHumanReadable } from '@/utils'
import { getStatus } from '@/utils/status'
import { ElMessage } from 'element-plus'
import { ref } from 'vue'

const emit = defineEmits<{
  (e: 'change'): void
}>()

const props = defineProps<{
  chatter: Chatter
}>()

const newNudge = ref<{
  outcome: { id: number } | string
  comment?: string
}>({
  outcome: '',
  comment: '',
})

const outcomes = ref<Array<{ id: number; value: string }>>([])
const getOutcomes = async () => {
  outcomes.value = await api.nudges.getOutcomes()
}
getOutcomes()

const addNudge = async () => {
  if (!newNudge.value.outcome) {
    ElMessage.error('Результат не выбран')
    return
  }
  await api.nudges.add({
    payload: {
      chatterId: props.chatter.id,
      stage: props.chatter.status,
      outcome: newNudge.value?.outcome,
      comment: newNudge.value?.comment,
    },
  })
  ElMessage.success('Подталкивание добавлено')
  newNudge.value = {
    outcome: '',
    comment: '',
  }
  getOutcomes()
  emit('change')
}
</script>
